import { api } from '../../api/api';
import {
  MENU_MASTER_REQUEST, GET_MENU_MASTER_SUCCESS, ADD_MENU_MASTER_SUCCESS,
  UPDATE_MENU_MASTER_SUCCESS, DELETE_MENU_MASTER_SUCCESS, MENU_MASTER_FLAG_OFF,
} from '../constant';

export const getMenuMasterItems = (category) => async (dispatch) => {
  dispatch({ type: MENU_MASTER_REQUEST });
  try {
    const url = category ? `/menu-master/items?category=${category}` : '/menu-master/items';
    const { data } = await api.get(url);
    dispatch({ type: GET_MENU_MASTER_SUCCESS, payload: data.items || [] });
  } catch (e) {
    console.error(e);
  }
};

export const addMenuMasterItem = (obj) => async (dispatch) => {
  try {
    const { data } = await api.post('/menu-master/items', obj);
    dispatch({ type: ADD_MENU_MASTER_SUCCESS, payload: data.item });
  } catch (e) {
    console.error(e);
  }
};

export const updateMenuMasterItem = (id, obj) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/menu-master/items/${id}`, obj);
    dispatch({ type: UPDATE_MENU_MASTER_SUCCESS, payload: data.item });
  } catch (e) {
    console.error(e);
  }
};

export const deleteMenuMasterItem = (id) => async (dispatch) => {
  try {
    await api.delete(`/menu-master/items/${id}`);
    dispatch({ type: DELETE_MENU_MASTER_SUCCESS, payload: id });
  } catch (e) {
    console.error(e);
  }
};

export const menuMasterFlagOff = () => ({ type: MENU_MASTER_FLAG_OFF });

export const createMenuFormLink = (subuserId) => async (dispatch) => {
  const { data } = await api.post('/menu/create-form-link', { subuserId });
  return data?.link ?? null;
};

export const seedMenuMaster = () => async (dispatch) => {
  await api.post('/menu-master/seed');
  dispatch(getMenuMasterItems());
};
